import React, { useState, useEffect, useRef } from "react";
import {
  ActivityIndicator,
  StyleSheet,
  View,
  Dimensions,
} from "react-native-web";
import { Constants, Fonts } from "../../../config";
import { useTranslation } from "react-i18next";
import SectionTitleView from "../components/SectionTitleView";
import { ArtistDao, EventDao, FestivalDao, VenueDao } from "../../../DAO";
import { CardList } from "../../../components/molecules";

const { width: widthScreen } = Dimensions.get("window");

const RecommendedListSectionContainer = (props) => {
  const flatListRef = useRef(null);
  let page = 0;
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const { isChartsMode } = props;

  const loadItems = (category) => {
    setIsLoading(true);
    if (category === Constants.categoryType.CATEGORY_VENUE) {
      VenueDao.find({
        ...props.paramsVenue,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_ROOFTOP) {
      VenueDao.find({
        ...props.paramsRooftop,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_SPA) {
      VenueDao.find({
        ...props.paramsSpa,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_VENUE_BEACHFUL) {
      VenueDao.find({
        ...props.paramsVenueBeachful,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_PREFAB_COMPANY) {
      VenueDao.find({
        ...props.paramsPrefabCompany,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_PREFAB_HOMES) {
      VenueDao.find({
        ...props.paramsPrefabHome,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_ZOO) {
      VenueDao.find({
        ...props.paramsZoo,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_ANIMAL) {
      VenueDao.find({
        ...props.paramsAnimal,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_PARKFUL) {
      VenueDao.find({
        ...props.paramsParkful,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_CASINO) {
      VenueDao.find({
        ...props.paramsCasino,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_CASTLE) {
      VenueDao.find({
        ...props.paramsCastle,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_RESORT) {
      VenueDao.find({
        ...props.paramsResort,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_APARTHOTEL) {
      VenueDao.find({
        ...props.paramsAparthotel,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_VENUE_COCKTAIL) {
      VenueDao.find({
        ...props.paramsVenueCocktail,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_EVENT) {
      EventDao.findWeb({
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
        countryId: props.locationSelected?.country_id
          ? [props.locationSelected?.country_id]
          : null,
        cityId: props.locationSelected?.city_id,
        pageSize: 7,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_FESTIVAL) {
      FestivalDao.findWeb({
        ...props.paramsFestival,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
        dateSortType: Constants.dateFilterType.DATE_FILTER_UPCOMING,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === Constants.categoryType.CATEGORY_ARTIST) {
      ArtistDao.findWeb({
        ...props.paramsArtist,
        sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
      }).then((result) => {
        setIsLoading(false);
        setItems(result.data);
      });
    } else {
      setIsLoading(false);
      setItems([]);
    }
  };

  useEffect(() => {
    loadItems(props.category);
  }, [
    props.category,
    JSON.stringify(props.locationSelected),
    props.filterCriteriaListOriginalFestival,
    props.filterCriteriaListOriginalEvent,
    props.filterCriteriaListOriginalArtist,
    props.filterCriteriaListOriginalVenue,
    props.filterCriteriaListOriginalRooftop,
    props.filterCriteriaListOriginalSpa,
    props.filterCriteriaListOriginalVenueBeachful,
    props.filterCriteriaListOriginalVenueCocktail,
  ]);

  return (
    <View style={[styles.container, props.style]}>
      <SectionTitleView title={t("key_recommended")} />
      {isLoading ? (
        <ActivityIndicator />
      ) : (
        <CardList
          ref={flatListRef}
          horizontal={true}
          items={items}
          category={props.category}
          style={{ marginLeft: 16, marginTop: 16, overflow: "hidden" }}
          isChartsMode={isChartsMode}
          // onItemAction={onItemAction}
        />
      )}
      {items.length > (widthScreen < 1536 ? 3 : 4) && (
        <div className="w-full flex flex-row justify-between max-w-198px mx-auto -mt-2">
          <div
            className="cursor-pointer"
            onClick={() => {
              if (page - 1 >= 0) {
                page--;
              }
              const newIndex = page * (widthScreen < 1536 ? 3 : 4);
              flatListRef?.current?.scrollToIndex({
                animated: true,
                index: newIndex,
              });
            }}>
            <img
              src={`/icons/${
                process.env.NEXT_PUBLIC_APP_NAME === "Zoopedia" ||
                process.env.NEXT_PUBLIC_APP_NAME === "PrefabWorld" ||
                process.env.NEXT_PUBLIC_APP_NAME === "Parkful" ||
                process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino" ||
                process.env.NEXT_PUBLIC_APP_NAME === "Castlepedia" ||
                process.env.NEXT_PUBLIC_APP_NAME === "LuxResort Club" ||
                process.env.NEXT_PUBLIC_APP_NAME === "AparthotelClub" ||
                process.env.NEXT_PUBLIC_APP_NAME === "RooftopClub" ||
                process.env.NEXT_PUBLIC_APP_NAME === "Cocktayl" ||
                process.env.NEXT_PUBLIC_APP_NAME === "SpaClub" ||
                process.env.NEXT_PUBLIC_APP_NAME === "Beachful"
                  ? process.env.NEXT_PUBLIC_APP_NAME?.replace(
                      " ",
                      ""
                    )?.toLowerCase() + "/"
                  : ""
              }ic_arrow_left.png`}
              width="40"
              height="40"
              alt="arrow"
            />
          </div>
          <div
            className="cursor-pointer"
            onClick={() => {
              if (
                page + 1 <
                Math.round(items.length / (widthScreen < 1536 ? 3 : 4))
              ) {
                page++;
              }
              const newIndex = page * (widthScreen < 1536 ? 3 : 4);
              flatListRef?.current?.scrollToIndex({
                animated: true,
                index: newIndex,
              });
            }}>
            <img
              src={`/icons/${
                process.env.NEXT_PUBLIC_APP_NAME === "Zoopedia" ||
                process.env.NEXT_PUBLIC_APP_NAME === "PrefabWorld" ||
                process.env.NEXT_PUBLIC_APP_NAME === "Parkful" ||
                process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino" ||
                process.env.NEXT_PUBLIC_APP_NAME === "Castlepedia" ||
                process.env.NEXT_PUBLIC_APP_NAME === "LuxResort Club" ||
                process.env.NEXT_PUBLIC_APP_NAME === "AparthotelClub" ||
                process.env.NEXT_PUBLIC_APP_NAME === "RooftopClub" ||
                process.env.NEXT_PUBLIC_APP_NAME === "Cocktayl" ||
                process.env.NEXT_PUBLIC_APP_NAME === "SpaClub" ||
                process.env.NEXT_PUBLIC_APP_NAME === "Beachful"
                  ? process.env.NEXT_PUBLIC_APP_NAME?.replace(
                      " ",
                      ""
                    )?.toLowerCase() + "/"
                  : ""
              }ic_arrow_right.png`}
              width="40"
              height="40"
              alt="arrow"
            />
          </div>
        </div>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    overflow: "hidden",
    width: "100%",
  },
  titleSection: {
    flexDirection: "row",
    alignSelf: "stretch",
    alignItems: "center",
  },
  title: {
    fontSize: 16,
    fontFamily: Fonts.primaryBold,
  },
  viewAllBtn: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: Fonts.primaryRegular,
  },
});

export default RecommendedListSectionContainer;
